import React from 'react';
import Button from '../../Button';
import Col from '../../Col';
import ServiceRequestFormDialog from '../ServiceRequestFormDialog';
import Row from '../../Row';
import FaqEmbed from 'src/components/Faqs/SubComponents/FawEmbed/FaqEmbed';
import {
  useServiceRequestFormFaqsOrchestrator,
  UseServiceRequestFormFaqsOrchestratorReturn,
} from './useServiceRequestFormFaqsOrchestrator';
import './ServiceRequestFormFaqs.scss';

interface FaqAnswerContentProps {
  answer: string;
  embed?: string;
  uploadType?: string;
  image?: string;
}

const FaqAnswerContent = ({
  answer,
  embed,
  uploadType,
  image,
}: FaqAnswerContentProps) => {
  const hasEmbed: boolean = Boolean(embed && embed.length > 0);
  const hasImage: boolean = uploadType === 'Image' && Boolean(image);
  const hasVideo: boolean = uploadType !== 'Image' && Boolean(image);

  const renderAttachment = () => {
    if (hasEmbed) {
      return (
        <div className="sr-form-faqs__embed">
          <FaqEmbed embedCode={embed} />
        </div>
      );
    }

    if (hasImage) {
      return (
        <div className="sr-form-faqs__photo embed-video">
          <a href={image} target="_blank" rel="noreferrer">
            <img src={image} alt="" />
          </a>
        </div>
      );
    }

    if (hasVideo) {
      return (
        <video width="250" height="210" controls>
          <source src={image} type="video/mp4" />
        </video>
      );
    }

    return <div className="sr-form-faqs__no-attachment">No attachment found.</div>;
  };

  return (
    <Row mdCenter>
      <Col xs="12" md="6">
        <div>
          <div>
            <b>Answer:</b>
          </div>
          <div className="sr-form-faqs__body">
            <div dangerouslySetInnerHTML={{ __html: answer }} />
          </div>
          <div className="sr-form-faqs__attachment">{renderAttachment()}</div>
        </div>
      </Col>
    </Row>
  );
};

interface FaqResolutionFooterProps {
  onResolved: () => void;
  onNotResolved: () => void;
}

const FaqResolutionFooter = ({
  onResolved,
  onNotResolved,
}: FaqResolutionFooterProps) => {
  return (
    <>
      <span className="sr-form-faqs__resolution-prompt">
        Did this help you resolve the issue?
      </span>
      <Button
        color="teal"
        size="small"
        label="Yes, Return to Dashboard"
        onClick={onResolved}
      />
      <Button
        color="teal"
        size="small"
        label="No, NEXT: ADD DETAILS"
        onClick={onNotResolved}
      />
    </>
  );
};

const ServiceRequestFormFaqs = () => {
  const {
    faq,
    onNotResolved,
    onBack,
    onExit,
  }: UseServiceRequestFormFaqsOrchestratorReturn =
    useServiceRequestFormFaqsOrchestrator();

  return (
    <ServiceRequestFormDialog
      title={'Question: ' + faq.question}
      onBack={onBack}
      onExit={onExit}
      footer={
        <FaqResolutionFooter
          onResolved={onExit}
          onNotResolved={onNotResolved}
        />
      }
    >
      <FaqAnswerContent
        answer={faq.answer}
        embed={faq.Embed}
        uploadType={faq.uploadType}
        image={faq.image}
      />
    </ServiceRequestFormDialog>
  );
};

export default ServiceRequestFormFaqs;